import React, { useState, useEffect } from 'react';
import TableDocuments from './TableDocuments';
import Select from 'react-select';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import Contenedor from '../GlobalComponents/Contenedor';
import InputFile from '../../utils/InputFile';
import SvgIcon from '../../utils/Icon';
import { ReactComponent as Buscar } from '../../assets/icons/lupa.svg';
import { ReactComponent as Perfil } from "../../assets/icons/perfilUsuario.svg";
import { ReactComponent as Administradores } from "../../assets/icons/Administradores.svg";

import Modal from 'react-modal';
import { useDataUser } from '../../context/dataUserContext';
Modal.setAppElement('#root');

const AdminComponent = () => {
    const [showForm, setShowForm] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [filesToEdit, setFilesToEdit] = useState([]);
    const { clinicId } = useDataUser();


    const fetchAdmins = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getAdmins/${clinicId}`);
            console.log(response.data);
            setAdmins(response.data);
        } catch (error) {
            console.error('Error fetching admins:', error);
        }
    };

    useEffect(() => {
        fetchAdmins();
    }, []);

    const handleShowForm = () => {
        setShowForm(true);
    };

    const handleGoBack = () => {
        setShowForm(false);
        //setShowCalendar(false); // Oculta el calendario al volver
        setShowChangePassword(false);
        setShowProfile(false);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredAdmins = admins.filter(admin => {
        const searchTermLower = searchTerm.toLowerCase();
        return (
            admin.firstName?.toLowerCase().includes(searchTermLower) ||
            admin.firstLastName?.toLowerCase().includes(searchTermLower) ||
            admin.email?.toLowerCase().includes(searchTermLower) ||
            admin.cellNumber?.toLowerCase().includes(searchTermLower) ||
            admin.idNumber?.toLowerCase().includes(searchTermLower)
        );
    });

    const handleMenuOptionClick = (option) => {
        switch (option) {
            case 'Eliminar Administrador':
                handleDeleteAdmin();
                break;
            case 'Cambiar Contraseña':
                setShowChangePassword(true);
                break;
            case 'Perfil':
                setShowProfile(true);
                break;
            default:
                break;
        }
    };

    const handleDeleteAdmin = async () => {
        try {
            alertaGeneral({
                titulo: "¿Estás seguro?",
                messageHtml: "Una vez eliminado, no podrás recuperar esta información.",
                isWarning: true,
                cancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Sí, eliminar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await apiClient.put(`/api/clinic/deleteAdmin/${selectedAdmin._id}`);

                    if (response.status === 200) {
                        alertaGeneral({
                            titulo: "Eliminado",
                            messageHtml: "El administrador ha sido eliminado"
                        });
                        setAdmins(admins.filter(admin => admin._id !== selectedAdmin._id));
                    } else {
                        alertaGeneral({
                            titulo: "Error",
                            messageHtml: "No se pudo eliminar el administrador. Inténtalo de nuevo.",
                            isError: true
                        });
                    }
                }
            })

        } catch (error) {
            console.error('Error deleting admin:', error);
            alertaGeneral({
                titulo: "Error",
                messageHtml: "No se pudo eliminar el administrador. Inténtalo de nuevo.",
                isError: true
            });
        }
    };

    const handleEditAdmin = async () => {
        try {
            const dataAdminToSend = new FormData();

            for (const key in selectedAdmin) {
                dataAdminToSend.append(key, selectedAdmin[key]);
            }

            for (const key in filesToEdit) {
                dataAdminToSend.append(key, filesToEdit[key]);
            }

            const response = await apiClient.put(`/api/clinic/editAdmin/${selectedAdmin._id}`, dataAdminToSend);

            if (response.status === 200) {
                alertaGeneral({
                    titulo: 'Administrador Editado',
                    messageHtml: 'El Administrador ha sido editado exitosamente.',
                })
                setShowProfile(false);
                fetchAdmins();

            } else {
                alertaGeneral({
                    titulo: 'Error editando Administrador',
                    messageHtml: 'El administrador no pudo ser editado',
                    isError: true
                })
            }
        } catch (error) {
            console.error('Error updating patient information:', error);
            alertaGeneral({
                titulo: 'Error editando Administrador',
                messageHtml: 'El administrador no pudo ser editado',
                isError: true
            })
        }
    };

    const lstDocumentsExists = [
        { nameToSave: 'foto_perfil', name: 'Foto Del Perfil', url: selectedAdmin?.urlPictureProfile || '', isEdit: true },
        { nameToSave: 'cedulaPDF', name: 'Documento Identidad', url: selectedAdmin?.urlFileDocument || '', isEdit: true }
    ]

    if (showProfile) {
        return (
            <Contenedor icon={Perfil} title={"Editar perfil"} >
                <form>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">
                        {/* Personal Information Fields */}
                        <div>
                            <label className="form-label">Nombre</label>
                            <input
                                type="text"
                                value={selectedAdmin.firstName}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, firstName: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Segundo Nombre</label>
                            <input
                                type="text"
                                value={selectedAdmin.secondName}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, secondName: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Primer Apellido</label>
                            <input
                                type="text"
                                value={selectedAdmin.firstLastName}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, firstLastName: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Segundo Apellido</label>
                            <input
                                type="text"
                                value={selectedAdmin.secondLastName}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, secondLastName: e.target.value })}
                                className="form-input"
                            />
                        </div>

                        <div>
                            <label className="form-label">Correo Electrónico</label>
                            <input
                                type="email"
                                value={selectedAdmin.email}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, email: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Número de Teléfono</label>
                            <input
                                type="tel"
                                value={selectedAdmin.cellNumber}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, cellNumber: e.target.value })}
                                className="form-input"
                            />
                        </div>


                        <div>
                            <label className="form-label">Calle</label>
                            <input
                                type="text"
                                value={selectedAdmin.street}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, street: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Número Exterior</label>
                            <input
                                type="text"
                                value={selectedAdmin.exteriorNumber}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, exteriorNumber: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Número Interior</label>
                            <input
                                type="text"
                                value={selectedAdmin.interiorNumber}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, interiorNumber: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Barrio</label>
                            <input
                                type="text"
                                value={selectedAdmin.neighborhood}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, neighborhood: e.target.value })}
                                className="form-input"
                            />
                        </div>

                        {/* Identification Documents Fields */}
                        <div>
                            <label className="form-label">Tipo de Identificación</label>
                            <input
                                type="text"
                                value={selectedAdmin.idType}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, idType: e.target.value })}
                                className="form-input"
                            />
                        </div>
                        <div>
                            <label className="form-label">Número de Identificación</label>
                            <input
                                type="text"
                                value={selectedAdmin.idNumber}
                                onChange={(e) => setSelectedAdmin({ ...selectedAdmin, idNumber: e.target.value })}
                                className="form-input"
                            />
                        </div>

                    </div>
                    <div className="flex justify-end mt-4 gap-3">
                        <button
                            onClick={handleGoBack}
                            className="button-gray"
                        >
                            Volver
                        </button>
                        <button
                            type="button"
                            onClick={handleEditAdmin}
                            className="button-send"
                        >
                            Guardar cambios
                        </button>
                    </div>
                </form>
                <TableDocuments
                    lstDocuments={lstDocumentsExists ? lstDocumentsExists : null}
                    filesToEdit={filesToEdit}
                    setFilesToEdit={setFilesToEdit}
                />
            </Contenedor>
        );
    }
    const closeChangePasswordModal = () => {
        setShowChangePassword(false);
    };

    const handleChangePassword = async () => {
        try {

            const response = await apiClient.post(`/api/clinic/changePasswordPatient`, {
                username: selectedAdmin.email,
                newPassword: newPassword
            });

            if (response.status === 200) {
                alertaGeneral({
                    titulo: "Contraseña cambiada con éxito",
                })
                setNewPassword('');
                closeChangePasswordModal();
            } else {
                alertaGeneral({
                    titulo: "Contraseña actual incorrecta",
                    isError: true
                });
            }

        } catch (error) {
            alertaGeneral({
                titulo: "Error inesperado",
                isError: true
            })
        }
    };

    return (
        <div>
            {!showForm ? (
                <Contenedor icon={Administradores} title="Administradores">
                    <div className="flex flex-col md:flex-row justify-end gap-3 mb-6">
                        <div className="flex items-center">
                            <span className="flex bg-[#1f94c2ff] text-white p-2">
                                <SvgIcon Icon={Buscar} className={"w-5 h-5"} />
                            </span>
                            <input type="text"
                                placeholder="Buscar administrador"
                                className="w-64 p-[5px] border-t border-r border-b border-[#6e787aff] focus:outline-none"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <button
                            onClick={handleShowForm}
                            className="button-add"
                        >
                            Agregar administrador
                        </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-h-[550px] overflow-auto">
                        {filteredAdmins.map((admin, index) => (
                            <div key={index} className="bg-gray-200 rounded-lg overflow-hidden p-4">
                                <div className="flex flex-row items-center gap-2">
                                    <img
                                        className="hidden sm:flex w-[180px] h-[180px]  border border-gray-400 object-contain"
                                        src={admin.urlPictureProfile}
                                        alt="Profile"
                                        referrerPolicy="no-referrer"
                                    />
                                    <div className="text-left w-full">
                                        <h2 className="text-xl font-bold text-[#205087ff]">{admin.firstName} {admin.firstLastName}</h2>
                                        <hr className="border-[#205087ff] my-1 w-full" />
                                        <p className="form-label">{admin.firstName} {admin.firstLastName}</p>
                                        <p className="form-label">Cel.: {admin.cellNumber}</p>
                                        <p className="form-label uppercase">{admin.idType}</p>
                                        <p className="form-label">N°. {admin.idNumber}</p>
                                    </div>
                                </div>
                                <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center gap-2" onClick={() => setSelectedAdmin(admin)}>
                                    <button
                                        className="button-action px-3"
                                        onClick={() => handleMenuOptionClick('Perfil')}
                                    >
                                        Editar perfil
                                    </button>
                                    <button
                                        className="button-action px-3"
                                        onClick={() => handleMenuOptionClick('Cambiar Contraseña')}
                                    >
                                        Cambiar contraseña
                                    </button>
                                    <button
                                        className="button-action px-3"
                                        onClick={() => handleMenuOptionClick('Eliminar Administrador')}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </Contenedor>
            ) : (
                <Admin onGoBack={handleGoBack} fetchAdmins={fetchAdmins} />

            )}

            {showChangePassword && (
                <Modal
                    isOpen={showChangePassword}
                    onRequestClose={closeChangePasswordModal}
                    shouldCloseOnOverlayClick={false}
                    className="w-[420px] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
                    overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[20]"
                >
                    <h2 className="text-lg text-left text-[#205087ff] font-bold mb-4">CAMBIAR CONTRASEÑA PARA {selectedAdmin.email}</h2>

                    <div className="flex flex-col justify-start">
                        <div className="flex items-center mb-4 gap-2">
                            <label className="form-label text-nowrap">Nueva contraseña:</label>
                            <input
                                type="password"
                                className="py-1 form-input"
                                placeholder='******'
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="flex justify-center gap-3">
                        <button
                            className="button-send"
                            onClick={handleChangePassword}
                        >
                            Cambiar
                        </button>
                        <button
                            onClick={() => setShowChangePassword(false)}
                            className="button-gray"
                        >
                            Cancelar
                        </button>
                    </div>
                </Modal>
            )}
        </div >
    );
};



const Admin = ({ onGoBack, fetchAdmins }) => {
    const { clinicId } = useDataUser();
    const [departments, setDepartments] = useState([]);
    const [cities, setCities] = useState([]);
    const [formData, setFormData] = useState({
        foto_perfil: '',
        dob: '',
        birthCountry: '',
        residenceCountry: '',
        municipio: '',
        city: '',
        street: '',
        exteriorNumber: '',
        interiorNumber: '',
        neighborhood: '',
        firstName: '',
        secondName: '',
        firstLastName: '',
        secondLastName: '',
        gender: '',
        cellNumber: '',
        email: '',
        idType: '',
        idNumber: '',
        cedulaPDF: '',
        /* hasMedicalInsurance: 'no',
        insuranceName: '',
        insuranceNumber: '',
        hasCarer: 'no',
        carerFirstName: '',
        carerSecondName: '',
        carerFirstLastName: '',
        carerSecondLastName: '',
        carerRelationship: '',
        carerIdType: '',
        carerIdNumber: '', */
    });

    useEffect(() => {
        // Fetch departments when modal opens
        const fetchDepartments = async () => {
            try {
                const response = await apiClient.get(`/api/clinic/departments`);
                setDepartments(response.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };

        fetchDepartments();

    }, []);

    useEffect(() => {
        if (formData.department) {
            // Fetch municipalities when a department is selected
            const fetchCities = async () => {
                if (formData.department) {
                    try {
                        const response = await apiClient.get(`/api/clinic/cities/${formData.department}`);
                        setCities(response.data);
                    } catch (error) {
                        console.error('Error fetching cities:', error);
                    }
                }
            };

            fetchCities();
        } else {
            setCities([]);
        }
    }, [formData.department]);

    const handleDepartmentChange = (event) => {
        const selectedId = event.target.value;
        const selectedDepartment = departments.find(dept => dept._id === selectedId);

        setFormData({
            ...formData,
            department: selectedId, // ID del departamento
            departmentName: selectedDepartment ? selectedDepartment.departamento : '', // Nombre del departamento
        });
    };

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? files[0] : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.cedulaPDF || !formData.foto_perfil) {
            alertaGeneral({
                titulo: 'Debes subir los documentos requeridos',
                isError: true,
            });
            //Salimos de la funcion si no ha subido los documentos
            return;
        }

        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }
        formDataToSend.append('clinicId', clinicId);

        try {
            const response = await apiClient.post(`/api/clinic/adminInfo`, formDataToSend);

            if (response.status >= 200 && response.status < 300) {
                alertaGeneral({
                    titulo: "Administrador creado",
                }).then(() => onGoBack());
                fetchAdmins();
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error al crear el administrador';
            alertaGeneral({
                titulo: 'Error al crear el administrador',
                messageHtml: errorMessage,
                isError: true,
            });
        }
    };

    const [municipios, setMunicipios] = useState([]);
    const [paises, setPaises] = useState([]);

    const fetchMunicipios = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getMunicipios`);
            setMunicipios(response.data);
        } catch (error) {
            console.error('Error fetching municipios:', error);
        }
    };
    useEffect(() => {
        fetchMunicipios();
    }, []);
    const fetchPaises = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getPaises`);
            setPaises(response.data);
        } catch (error) {
            console.error('Error fetching países:', error);
        }
    };

    // Llama a fetchPaises cuando el componente se monte
    useEffect(() => {
        fetchPaises();
    }, []);

    const opcionesPaises = paises.map(pais => ({
        value: `${pais.Codigo} - ${pais.Nombre}`,
        label: pais.Nombre,
    }));
    const opcionesMunicipios = municipios.map(municipio => ({
        value: `${municipio.Codigo} - ${municipio.Nombre}`,
        label: municipio.Nombre,
    }));

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <Contenedor icon={Perfil} title="Agregar nuevo administrador">
            <form className="space-y-6" onSubmit={handleSubmit} encType="multipart/form-data" >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                    {/* Imagen */}
                    <div className="col-span-1">

                        <label className="form-label">Imagen *</label>
                        <InputFile
                            name="foto_perfil"
                            fileName={formData.foto_perfil?.name}
                            onChange={handleChange}
                            accept="image/*"
                        />
                    </div>

                    {/* Documento (Adjuntar) */}
                    <div className="col-span-1">
                        <label className="form-label">Documento Identidad *</label>
                        <InputFile
                            name="cedulaPDF"
                            fileName={formData.cedulaPDF?.name}
                            onChange={handleChange}
                            accept="application/pdf"
                        />
                    </div>

                    {/* Fecha de Nacimiento */}
                    <div className="col-span-1">
                        <label className="form-label">Fecha de Nacimiento *</label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                    </div>

                    {/* País de Nacimiento */}
                    <div className="form-group">
                        <label className="block text-gray-700">País de Nacimiento *</label>
                        <Select
                            name="birthCountry"
                            value={opcionesPaises.find(option => option.value === formData.birthCountry)}
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, birthCountry: selectedOption.value })
                            }
                            options={opcionesPaises}
                            placeholder="Selecciona un país"
                            className="w-full"
                        />
                    </div>

                    {/* País de Residencia */}
                    <div className="form-group">
                        <label className="block text-gray-700">País de Residencia *</label>
                        <Select
                            name="residenceCountry"
                            value={opcionesPaises.find(option => option.value === formData.residenceCountry)}
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, residenceCountry: selectedOption.value })
                            }
                            options={opcionesPaises}
                            placeholder="Selecciona un país"
                            className="w-full"
                        />
                    </div>

                    {/* Estado */}
                    <div className="form-group">
                        <label className="block text-gray-700">Municipio / Ciudad *</label>
                        <Select
                            name="municipio"
                            value={opcionesMunicipios.find(option => option.value === formData.residenceCountry)}
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, municipio: selectedOption.value })
                            }
                            options={opcionesMunicipios}
                            placeholder="Selecciona un municipio"
                            className="w-full"
                        />
                    </div>

                    {/* Primer Nombre */}
                    <div className="col-span-1">
                        <label className="form-label">Primer Nombre *</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Primer Nombre"
                            required
                        />
                    </div>

                    {/* Segundo Nombre */}
                    <div className="col-span-1">
                        <label className="form-label">Segundo Nombre</label>
                        <input
                            type="text"
                            name="secondName"
                            value={formData.secondName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Segundo Nombre"
                        />
                    </div>

                    {/* Primer Apellido */}
                    <div className="col-span-1">
                        <label className="form-label">Primer Apellido *</label>
                        <input
                            type="text"
                            name="firstLastName"
                            value={formData.firstLastName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Primer Apellido"
                            required
                        />
                    </div>

                    {/* Segundo Apellido */}
                    <div className="col-span-1">
                        <label className="form-label">Segundo Apellido</label>
                        <input
                            type="text"
                            name="secondLastName"
                            value={formData.secondLastName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Segundo Apellido"
                        />
                    </div>

                    {/* Género */}
                    <div className="col-span-1">
                        <label className="form-label">Género *</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="" disabled>Selecciona un género</option>
                            <option value="male">Masculino</option>
                            <option value="female">Femenino</option>
                            <option value="non-binary">No Binario</option>
                            <option value="other">Otro</option>
                            <option value="prefer-not-to-say">Prefiero no decirlo</option>
                        </select>
                    </div>

                    {/* Número de Celular */}
                    <div className="col-span-1">
                        <label className="form-label">Número de Celular *</label>
                        <input
                            type="text"
                            name="cellNumber"
                            value={formData.cellNumber}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Número de Celular"
                            required
                        />
                    </div>

                    {/* Correo Electrónico */}
                    <div className="col-span-1">
                        <label className="form-label">Correo Electrónico *</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Correo Electrónico"
                            required
                        />
                    </div>

                    {/* Tipo de ID */}
                    <div className="col-span-1">
                        <label className="form-label">Tipo de ID *</label>
                        <select
                            name="idType"
                            value={formData.idType}
                            onChange={handleSelectChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona</option>
                            <option value="CC">CC</option>
                            <option value="TI">TI</option>
                            <option value="CE">CE</option>
                            <option value="PS">PS</option>
                            <option value="DE">DE</option>
                        </select>
                    </div>

                    {/* Número de ID */}
                    <div className="col-span-1">
                        <label className="form-label">Número de ID *</label>
                        <input
                            type="text"
                            name="idNumber"
                            value={formData.idNumber}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Número de ID"
                            required
                        />
                    </div>

                </div>

                <div className="flex justify-end mt-4 gap-3">
                    <button
                        onClick={onGoBack}
                        className="button-gray"
                    >
                        Volver
                    </button>
                    <button
                        type="submit"
                        className="button-send"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </Contenedor>
    );
}

export default AdminComponent;
